import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({ name: 'removeHyphen' })
export class RemoveHyphenPipe implements PipeTransform {

  titlecasePipe = new TitleCasePipe();

  transform(value: string): string {
    return this.titlecasePipe.transform(value?.replace(/[-]/gm, ' '));
  }
}
